"use client";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

import InfoBox from "@/components/InfoBox";
import {
  DEFAULT_USE_IN_VIEW_OPTIONS,
  ElementType,
} from "@/constants/tagular/main";
import useElementEvents from "@/hooks/eventing/useElementEvents";
import { AccreditationSection as AccreditationSectionType } from "@/monarch/rules/degreeDetailRedesignTrafficV5_2/types";

export interface AccreditationSectionProps extends AccreditationSectionType {
  showAccreditationSection: boolean;
}

type AccreditationProps = {
  className?: string;
  trackEvents?: boolean;
  degreeDetailAccreditation: AccreditationSectionProps;
};

const Accreditation = ({
  className,
  trackEvents = false,
  degreeDetailAccreditation,
}: AccreditationProps) => {
  const { elementViewed } = useElementEvents({
    webElement: {
      elementType: ElementType.Component,
      text: "School-accreditation",
      htmlId: "accreditation",
      name: "accreditation",
      location: "degree-detail-page",
      position: "1",
    },
  });

  const { ref: contentRef, inView } = useInView(DEFAULT_USE_IN_VIEW_OPTIONS);

  useEffect(() => {
    if (trackEvents && inView) {
      elementViewed();
    }
  }, [trackEvents, inView, elementViewed]);

  return (
    degreeDetailAccreditation?.showAccreditationSection && (
      <div className="pb-16" ref={contentRef}>
        <InfoBox
          showDisclaimer={false}
          heading={degreeDetailAccreditation?.title || ""}
          variant="degree-statistical"
          className={`[&_h2]:text-2xl lg:[&_h2]:text-3xl md:[&_h2]:mb-6 [&_h2]:my-0 ${className}`}
          icon={degreeDetailAccreditation?.image || ""}
          iconStyles={{
            width: 500,
            height: 500,
            style: {
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "cover",
            },
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: degreeDetailAccreditation?.description || "",
            }}
          />
        </InfoBox>
      </div>
    )
  );
};

export default Accreditation;
